export const containerStyles = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

export const flexCenterStyles = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
};

export const containerFlexCenterStyles = {
  ...containerStyles,
  display: 'flex',
  alignItems: 'center',
};
